import React, { useState } from 'react';
import { WeekChallengeCountdownTimer } from './week-challenge-countdown-timer';
import { WeekChallengeQuestion } from './week-challenge-question';
import { useWeeklyChallenge } from '@/hooks/useWeeklyChallenge';
import { ChallengeModalHeader, ChallengeModalHeaderContent, ChallengeModalSection, ChallengeModalSubtitle, ChallengeModalTitle } from '@/components/custom/challenge';
import { CardProgressWrapper } from '@/components/ui/card';

export default function WeekChallengeStepQuestion() {
  const { currentRound, amountRounds, currentChallenge } = useWeeklyChallenge();
  const [currentIndexQuestion, setCurrentIndexQuestion] = useState(0);

  const percentage = (currentIndexQuestion * 100) / amountRounds;

  return (
    <ChallengeModalSection variant="question">
      <ChallengeModalHeader>
        <ChallengeModalHeaderContent>
          <ChallengeModalTitle>{currentChallenge?.taxonomy?.name}</ChallengeModalTitle>
          <ChallengeModalSubtitle>Rodada {currentRound}</ChallengeModalSubtitle>
        </ChallengeModalHeaderContent>
        <WeekChallengeCountdownTimer className="shrink-0" />
      </ChallengeModalHeader>

      <CardProgressWrapper
        percentage={percentage}
        toFixed={2}
      />

      <WeekChallengeQuestion
        setCurrentIndexQuestion={setCurrentIndexQuestion}
        currentIndexQuestion={currentIndexQuestion}
      />
    </ChallengeModalSection>
  );
}
